import { render, staticRenderFns } from "./stretchBox.vue?vue&type=template&id=23a53d50&scoped=true"
import script from "./stretchBox.vue?vue&type=script&lang=js"
export * from "./stretchBox.vue?vue&type=script&lang=js"
import style0 from "./stretchBox.vue?vue&type=style&index=0&id=23a53d50&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23a53d50",
  null
  
)

export default component.exports